import { format, parseISO } from "date-fns";
import { de, enUS, es, fr, it } from "date-fns/locale";

const LOCALES = { en: enUS, de, fr, es, it };

export function getDateFnsLocale(languageTag) {
  const code = String(languageTag || "en").split("-")[0].toLowerCase();
  return LOCALES[code] || enUS;
}

export function formatDateTimePPp(value, languageTag) {
  if (value == null || value === "") return null;
  try {
    const d =
      value instanceof Date
        ? value
        : typeof value === "string"
          ? parseISO(value)
          : new Date(value);
    if (Number.isNaN(d.getTime())) return null;
    return format(d, "dd.MM.yyyy HH:mm", { locale: getDateFnsLocale(languageTag) });
  } catch {
    return null;
  }
}

export function formatEntityUpdatedAt(entity, languageTag) {
  const raw = entity?.updated_at ?? entity?.created_at;
  return formatDateTimePPp(raw, languageTag);
}
